import { Pipe } from '@angular/core';
import { isArray } from '../utils/utils';
var DropPipe = (function () {
    function DropPipe() {
    }
    DropPipe.prototype.transform = function (input, quantity) {
        if (!isArray(input)) {
            return input;
        }
        return input.slice(quantity || 1, input.lenth);
    };
    return DropPipe;
}());
export { DropPipe };
DropPipe.decorators = [
    { type: Pipe, args: [{
                name: 'drop'
            },] },
];
/** @nocollapse */
DropPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=drop.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/array/drop.pipe.js
// module id = 230
// module chunks = 103